import { invariant } from "./invariant.js";

const funcRegex =
	/^function(?:\s+([a-zA-Z$_][a-zA-Z0-9$_]*))?\s*\(((?:(?:\s*[a-zA-Z$_][a-zA-Z0-9$_]*)(?:\s*,\s*[a-zA-Z$_][a-zA-Z0-9$_]*)*)?)\s*\)\s*\{((?:.|\n|\r)*)\}$/;
const arrowBlockRegex = /^(?:\(([^)]*)\)|([a-zA-Z$_][a-zA-Z0-9$_]*))\s*=>\s*\{([\s\S]*)\}$/;
const arrowExpressionRegex = /^(?:\(([^)]*)\)|([a-zA-Z$_][a-zA-Z0-9$_]*))\s*=>\s*([\s\S]+)$/;

const parseArguments = (args: string) =>
	args
		.split(",")
		.map((a) => a.trim())
		.filter(Boolean);

export function parseFunc(func: (...args: any[]) => any) {
	const funcString = func.toString();
	const arrowBlockMatch = funcString.match(arrowBlockRegex);

	if (arrowBlockMatch) {
		const args = parseArguments(arrowBlockMatch[1] ?? arrowBlockMatch[2] ?? "");

		return { name: func.name, args, body: arrowBlockMatch[3] };
	}

	const arrowExpressionMatch = funcString.match(arrowExpressionRegex);

	if (arrowExpressionMatch) {
		const args = parseArguments(arrowExpressionMatch[1] ?? arrowExpressionMatch[2] ?? "");

		return { name: func.name, args, body: arrowExpressionMatch[3] };
	}

	const match = funcString.match(funcRegex);

	invariant(match, "Unable to parse function!");

	return { name: func.name ?? match[1], args: parseArguments(match[2]), body: match[3] };
}
